import { ShadowPulseApi } from "./api";

export const GetCurrentRelease = async (
    service: string,
): Promise<any> => {
    const api = await ShadowPulseApi();
    const apiResponse = await api
        .get(`release`)
        .then((result) => {
            return result.data;
        });

    return apiResponse;
};

export const GetDeployments = async (
    service: string,
): Promise<any> => {
    const api = await ShadowPulseApi();
    const apiResponse = await api
        .get(`deployments`)
        .then((result) => {
            return result.data;
        });

    return apiResponse;
};

export const GetReleases = async (
    service: string,
): Promise<any> => {
    const api = await ShadowPulseApi();
    const apiResponse = await api
        .get(`releases`)
        .then((result) => {
            return result.data;
        });

    return apiResponse;
};
